export default {
  SET_STATE: 'set-state',
  UPDATE_VIEWER_RENDERS_COUNTER: 'updateViewerRendersCounter',
};
